import React, { Component } from 'react';
import Select from 'react-select';
import OgaSelect from "../elements/OgaSelect";

export default class AccountTransTypeSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (status) => {
        this.props.handleChange(status);
    }

    render() {
        const statuses = [
            { value: null, label: 'TODOS' },            
            { value: 'COMMISSION_PAYMENT', label: 'PAGO DE COMISIÓN' },
            { value: 'TRANSFER', label: 'TRANSFERENCIA ENTRE BILLETERAS' }
        ];
        return (
            <OgaSelect
                bsSize="small"
                placeholder="Tipo de Transacción"
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={statuses}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AccountTransTypeSelect/AccountTransTypeSelect.jsx